
import React, { Component } from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    withStyles,
    TextField,
    Button,
    FormControl,
    MenuItem,
    Select,
    InputLabel
} from '@material-ui/core/';

//import SelectCountry from "../components/SelectCountry";
import SelectCountry from '@apricityhealth/web-common-lib/components/SelectCountry';

export const DEFAULT_ADDRESS = {
    country: 'US',
    addressType: 'home',
    street1: '',
    street2: '',
    city: '',
    state: '',
    postalCode: ''
};

class EditAddressDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: JSON.parse(JSON.stringify(props.address || DEFAULT_ADDRESS))
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.address !== this.props.address) {
            this.setState({ address: JSON.parse(JSON.stringify(this.props.address || DEFAULT_ADDRESS)) })
        }
    }

    render() {
        const { open, onDone, onCancel, onDelete } = this.props;
        const { address } = this.state;

        return <Dialog
            onClose={onCancel}
            aria-labelledby="customized-dialog-title"
            open={open || true}
        >
            <DialogTitle id="customized-dialog-title" onClose={onCancel}>
                {this.props.title || 'Address Details'}
            </DialogTitle>
            <DialogContent>
                <div style={{ width: '95%' }}>
                    <FormControl style={{width: 300, margin: 5}}>
                        <InputLabel>Type</InputLabel>
                        <Select value={address.addressType} onChange={(e) => this.setState({ address: { ...address, addressType: e.target.value }})}>
                            <MenuItem value='home'>Home</MenuItem>
                            <MenuItem value='work'>Work</MenuItem>
                            <MenuItem value='primary'>Primary</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        label="Street 1"
                        style={{ width: '100%', margin: '5px' }}
                        value={address.street1}
                        onChange={(e) => { address.street1 = e.target.value; this.setState({ address }) }}
                    />
                    <TextField
                        label="Street 2"
                        style={{ width: '100%', margin: '5px' }}
                        value={address.street2}
                        onChange={(e) => { address.street2 = e.target.value; this.setState({ address }) }}
                    />
                    <TextField
                        label="City"
                        style={{ width: '100%', margin: '5px' }}
                        value={address.city}
                        onChange={(e) => { address.city = e.target.value; this.setState({ address }) }}
                    />
                    <TextField
                        label="State"
                        style={{ margin: '5px' }}
                        value={address.state}
                        onChange={(e) => { address.state = e.target.value; this.setState({ address }) }}
                    />
                    <TextField
                        label="Postal Code"
                        style={{ margin: '5px' }}
                        value={address.postalCode}
                        onChange={(e) => { address.postalCode = e.target.value; this.setState({ address }) }}
                    />
                    <SelectCountry style={styles.country}
                        value={address.country}
                        onChange={(e) => { address.country = e; this.setState({ address }); }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                {onDone && <Button variant="contained" style={styles.button} onClick={() => onDone(address)}>Ok</Button>}
                {onDelete && <Button variant="contained" style={styles.button} onClick={onDelete}>Delete</Button>}
                {onCancel && <Button variant="contained" style={styles.button} onClick={onCancel}>Cancel</Button>}
            </DialogActions>
        </Dialog>;
    }
}

const styles = {
    button: {
        margin: 5
    },
    div: {
        margin: 10
    }
}

export default withStyles(styles)(EditAddressDialog);